import BaseTextField from "../../../../components/ui/BaseTextField";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const CustomHoursPay = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);

  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation,
  );
  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      }),
    );
    console.log("parsedValue", parsedValue, value);

    if (name === "customHours" && parsedValue <= 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "customHoursErrorMsg",
          data: "Total Hours is required",
        }),
      );
    }

    if (name === "customHours" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "customHoursErrorMsg",
          data: "",
        }),
      );
    }
    if (name === "Hours Rate should be more than 0" && parsedValue <= 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "customHoursRateErrorMsg",
          data: "Hours Rate should be more than 0",
        }),
      );
    }
    if (name === "customHoursRate" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "customHoursRateErrorMsg",
          data: "",
        }),
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-3">
      <div className="mr-10">
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={!!workOrderFormValidation.customHoursErrorMsg}
          errorMsg={workOrderFormValidation.customHoursErrorMsg}
          fullWidth
          fullHeight={false}
          id="customHours"
          name="customHours"
          label="Total Hours"
          requirement="required"
          labelShrink={false}
          value={payment.customHours}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>
      <div>
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={!!workOrderFormValidation.customHoursRateErrorMsg}
          errorMsg={workOrderFormValidation.customHoursRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="customHoursRate"
          name="customHoursRate"
          label="Hours Rate"
          requirement="required"
          labelShrink={false}
          value={payment.customHoursRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>
      <div className="mr-10">
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={!!workOrderFormValidation.hourlyRateErrorMsg}
          errorMsg={workOrderFormValidation.hourlyRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="hourlyRate"
          name="hourlyRate"
          label="Additional Hour Rate"
          optional={false}
          labelShrink={false}
          value={payment.hourlyRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
        <p className="mt-2 text-sm text-right">
          Additional hourly rates will be appoicable after total hours
        </p>
      </div>
    </div>
  );
};

export default CustomHoursPay;
